import { render } from "./CrudLicenca.vue?vue&type=template&id=033dfc5f&scoped=true"
import script from "./CrudLicenca.vue?vue&type=script&lang=ts"
export * from "./CrudLicenca.vue?vue&type=script&lang=ts"

import "./CrudLicenca.vue?vue&type=style&index=0&id=033dfc5f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-033dfc5f"

export default script